import styled from 'styled-components';
import C from '@assets/themes/colors';
interface IRootProps {
  isSelected?: boolean;
}
export const Root = styled.div`
  margin-top:6px;
  position: relative;
  padding: 0px 0px;
`;

export const ButtonContainer = styled.div`
  display:flex;
  margin-left: auto;
  margin-right: auto;
  width: 45px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  //background-color: #122442;
  background-color: ${(props: IRootProps) => props.isSelected ? "#122442" : ""};
  cursor: pointer;
  &:hover {
      background-color: ${C.GRAY}
    }
`;

export const OptionsList = styled.div`
  width: 175px;
  height: 32px;
  display: none;
  position: absolute;
  border-radius: 3px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
  z-index: 51;
  margin-top: 16px;
  padding: 14px 19.5px;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const ButtonOption = styled.div`
  display: flex;
  width: 44px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: ${(props: IRootProps) => props.isSelected ? "rgba(18, 36, 66, 0.1);" : ""};
  cursor: pointer;
  &:hover {
      background-color: ${C.GRAY}
    }
`;
